import { Injectable } from '@angular/core';

export const JSONRPC = '2.0';

export const EXPIRE_TIMES = {
    token: 3600 * 24 // 1 day
};

interface Config {
    dashboard: boolean;
    serverUrlXapi: OriginsXapi;
    dummyRequests: boolean;
    financial: boolean;
    config: boolean;
    admin: boolean;
    rfqs: boolean;
    clients: boolean;
    offers: boolean;
    orders: boolean;
    leads: boolean;
    cloffers: boolean;
    clorders: boolean;
    quotations: boolean;
    stock: boolean;
    configAlternativeQualities: boolean;
};

type AllConfig = {
    [key in Origins]: Config
}

enum Origins {
    PRODUCTION = 'https://senal.omnissimo.com/',
    STAGE = 'https://stage-senal.omnissimo.com/'
}

enum OriginsXapi {
    PRODUCTION = 'https://xapi-senal.omnissimo.com/',
    STAGE = 'https://stage-xapi-senal.omnissimo.com/'
}

@Injectable({
    providedIn: 'root'
})


export class ConfigService {
    private conditions: Config = {} as Config;
    private config: Config = {} as Config;

    private readonly allConfig: AllConfig = {
        [Origins.PRODUCTION]: {
            dummyRequests: true,
            serverUrlXapi: OriginsXapi.PRODUCTION,
            dashboard: true,
            financial: true,
            config: true,
            admin: true,
            rfqs: true,
            clients: true,
            offers: true,
            orders: true,
            leads: true,
            cloffers: true,
            clorders: true,
            quotations: false,
            stock: false,
            configAlternativeQualities: false
        },
        [Origins.STAGE]: {
            dummyRequests: true,
            serverUrlXapi: OriginsXapi.STAGE,
            dashboard: true,
            financial: true,
            config: true,
            admin: true,
            rfqs: true,
            clients: true,
            offers: true,
            orders: true,
            leads: true,
            cloffers: true,
            clorders: true,
            quotations: false,
            stock: true,
            configAlternativeQualities: false
        },
    };

    constructor() {
        const url = `${window.location.origin}/` as Origins;
        this.config = this.allConfig[url] ?? this.allConfig[Origins.STAGE];
        this.conditions = JSON.parse(JSON.stringify(this.config));
    }

    public getOriginalDashboard(): boolean {
        return this.config.dashboard;
    }

    public getDashboard(): boolean {
        return this.conditions.dashboard;
    }

    public setDashboard(dashboard: boolean): void {
        this.conditions.dashboard = dashboard;
    }

    public getServerUrlXapi(): string {
        return this.conditions.serverUrlXapi;
    }

    public getDummyRequests(): boolean {
        return this.conditions.dummyRequests;
    }

    // Admin Module
    public getOriginalAdmin(): boolean { return this.config.admin; }
    public setAdmin(value: boolean): void { this.conditions.admin = value; }
    public getAdmin(): boolean { return this.conditions.admin; }
    // Config Module
    public getOriginalConfig(): boolean { return this.config.config; }
    public setConfig(value: boolean): void { this.conditions.config = value; }
    public getConfig(): boolean { return this.conditions.config; }
    // Financial Module
    public getOriginalFinancial(): boolean { return this.config.financial; }
    public setFinancial(value: boolean): void { this.conditions.financial = value; }
    public getFinancial(): boolean { return this.conditions.financial; }
    // RFQs Module
    public getOriginalRfqs(): boolean { return this.config.rfqs; }
    public setRfqs(value: boolean): void { this.conditions.rfqs = value; }
    public getRfqs(): boolean { return this.conditions.rfqs; }
    // Clients Module
    public getOriginalClients(): boolean { return this.config.clients; }
    public setClients(value: boolean): void { this.conditions.clients = value; }
    public getClients(): boolean { return this.conditions.clients; }
    // Offers Module
    public getOriginalOffers(): boolean { return this.config.offers; }
    public setOffers(value: boolean): void { this.conditions.offers = value; }
    public getOffers(): boolean { return this.conditions.offers; }
    // Orders Module
    public getOriginalOrders(): boolean { return this.config.orders; }
    public setOrders(value: boolean): void { this.conditions.orders = value; }
    public getOrders(): boolean { return this.conditions.orders; }
    // Leads Module
    public getOriginalLeads(): boolean { return this.config.leads; }
    public setLeads(value: boolean): void { this.conditions.leads = value; }
    public getLeads(): boolean { return this.conditions.leads; }
    // Cloffers Module
    public getOriginalCloffers(): boolean { return this.config.cloffers; }
    public setCloffers(value: boolean): void { this.conditions.cloffers = value; }
    public getCloffers(): boolean { return this.conditions.cloffers; }
    // Clorders Module
    public getOriginalClorders(): boolean { return this.config.clorders; }
    public setClorders(value: boolean): void { this.conditions.clorders = value; }
    public getClorders(): boolean { return this.conditions.clorders; }
    // Quotations Module
    public getOriginalQuotations(): boolean { return this.config.quotations; }
    public setQuotations(value: boolean): void { this.conditions.quotations = value; }
    public getQuotations(): boolean { return this.conditions.quotations; }
    // Stock Module
    public getOriginalStock(): boolean { return this.config.stock; }
    public setStock(value: boolean): void { this.conditions.stock = value; }
    public getStock(): boolean { return this.conditions.stock; }
    // Config / alternative pipe qualities
    public getOriginalConfigAlternativeQualities(): boolean { return this.config.configAlternativeQualities; }
    public setConfigAlternativeQualities(value: boolean): void { this.conditions.configAlternativeQualities = value; }
    public getConfigAlternativeQualities(): boolean { return this.conditions.configAlternativeQualities; }
}